import CTAConversionMigration from './CTAConversionMigration';
import CTAVersioning from './CTAVersioning';

export default {
  ConversionMigration: CTAConversionMigration,
  Versioning: CTAVersioning,
};
